import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding-bottom":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Сохранить модель")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.isProductLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          size: "small",
          "label-position": "top",
          style: {"max-width":"460px","width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Фотомодель" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.selectedPhotomodels,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPhotomodels) = $event)),
                  class: "m-2",
                  placeholder: "Фотомодель не указана ",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePhotomodels, (photomodel) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: photomodel.id,
                        label: photomodel.name,
                        value: photomodel.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.setProductPhotomodel }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]))
    : _createCommentVNode("", true)
}